import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import TabellaConfermaLaboratorio from "../TabellaConfermaLaboratorio/TabellaConfermaLaboratorio";
import RadioButton from "../../../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../../../utils/Utils";

class ConfermaDiLaboratorioMorbillo extends Component {


    state = {
        confermaDiLaboratorioMorbillo: {

            esamiEffettuati: "",

            ricercaIgm: "",
            ricercaIgmElisaOAltro: "",
            ricercaIgmAltroValore: "",
            dataRaccoltaCampioneRicergaIgm: "",
            esitoRicercaIgm: "",
            tipoCampioneRicercaIgm: "",
            eventualeAltroRicercaIgm: "",

            ricercaIgg: "",
            ricercaIggElisaOAltro: "",
            ricercaIggAltroValore: "",
            primaDataRaccoltaCampioneRicergaIgg: "",
            secondaDataRaccoltaCampioneRicergaIgg: "",
            esitoRicercaIgg: "",
            tipoCampioneRicercaIgg: "",
            eventualeAltroRicercaIgg: "",

            pcr: "",
            dataRaccoltaCampionePcr: "",
            esitoPcr: "",
            tipoCampionePcr: "",
            eventualeAltroPcr: "",

            altroTest: "",
            altroTestValore: "",
            dataRaccoltaCampioneAltroTest: "",
            esitoAltroTest: "",
            tipoCampioneAltroTest: "",
            eventualeAltroAltroTest: "",

            genotipizzazione: "",
            ceppoGenotipizzazione: "",

            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {
        let confermaDiLaboratorioMorbillo = this.state.confermaDiLaboratorioMorbillo

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale &&
            this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio && this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio.morbillo) {
            let confermaDiLaboratorioMorbilloCopia = this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio.morbillo
            for (let key in confermaDiLaboratorioMorbillo) {
                if (confermaDiLaboratorioMorbillo.hasOwnProperty(key) === confermaDiLaboratorioMorbilloCopia.hasOwnProperty(key)) {
                    confermaDiLaboratorioMorbillo[key] = confermaDiLaboratorioMorbilloCopia[key]
                } else {
                    confermaDiLaboratorioMorbillo[key] = ""
                }
            }
            this.setState({confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo})
            this.controlloCorrettezza()
            this.props.updateConferme({
                confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo,
                corretto: confermaDiLaboratorioMorbillo.corretto
            })

        } else {
            this.controlloCorrettezza()
            this.props.updateConferme({
                confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo,
                corretto: confermaDiLaboratorioMorbillo.corretto
            })
        }
        Utils.disabledDateTabellaConfermaLaboratorio("Morbillo", this.state)

    }

    riceviValore(field, event) {
        let confermaDiLaboratorioMorbillo = this.state.confermaDiLaboratorioMorbillo
        let fieldFinale = field.replace("Morbillo", "")
        confermaDiLaboratorioMorbillo[fieldFinale] = event.target.value

        if (confermaDiLaboratorioMorbillo.esamiEffettuati !== "1") {
            confermaDiLaboratorioMorbillo.ricercaIgm = ""
            confermaDiLaboratorioMorbillo.ricercaIgmElisaOAltro = ""
            confermaDiLaboratorioMorbillo.ricercaIgmAltroValore = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm = ""
            confermaDiLaboratorioMorbillo.esitoRicercaIgm = ""
            confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgm = ""
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgm = ""

            confermaDiLaboratorioMorbillo.ricercaIgg = ""
            confermaDiLaboratorioMorbillo.ricercaIggElisaOAltro = ""
            confermaDiLaboratorioMorbillo.ricercaIggAltroValore = ""
            confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioMorbillo.esitoRicercaIgg = ""
            confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgg = ""
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgg = ""

            confermaDiLaboratorioMorbillo.pcr = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr = ""
            confermaDiLaboratorioMorbillo.esitoPcr = ""
            confermaDiLaboratorioMorbillo.eventualeAltroPcr = ""
            confermaDiLaboratorioMorbillo.tipoCampionePcr = ""

            confermaDiLaboratorioMorbillo.altroTest = ""
            confermaDiLaboratorioMorbillo.altroTestValore = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest = ""
            confermaDiLaboratorioMorbillo.esitoAltroTest = ""
            confermaDiLaboratorioMorbillo.tipoCampioneAltroTest = ""
            confermaDiLaboratorioMorbillo.eventualeAltroAltroTest = ""

            confermaDiLaboratorioMorbillo.genotipizzazione = ""
            confermaDiLaboratorioMorbillo.ceppoGenotipizzazione = ""

        }

        if (confermaDiLaboratorioMorbillo.ricercaIgm !== "true") {
            confermaDiLaboratorioMorbillo.ricercaIgm = ""
            confermaDiLaboratorioMorbillo.ricercaIgmElisaOAltro = ""
            confermaDiLaboratorioMorbillo.ricercaIgmAltroValore = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm = ""
            confermaDiLaboratorioMorbillo.esitoRicercaIgm = ""
            confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgm = ""
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgm = ""
        }
        if (confermaDiLaboratorioMorbillo.ricercaIgg !== "true") {
            confermaDiLaboratorioMorbillo.ricercaIgg = ""
            confermaDiLaboratorioMorbillo.ricercaIggElisaOAltro = ""
            confermaDiLaboratorioMorbillo.ricercaIggAltroValore = ""
            confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioMorbillo.esitoRicercaIgg = ""
            confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgg = ""
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgg = ""
        }
        if (confermaDiLaboratorioMorbillo.pcr !== "true") {
            confermaDiLaboratorioMorbillo.pcr = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr = ""
            confermaDiLaboratorioMorbillo.esitoPcr = ""
            confermaDiLaboratorioMorbillo.eventualeAltroPcr = ""
            confermaDiLaboratorioMorbillo.tipoCampionePcr = ""
        }
        if (confermaDiLaboratorioMorbillo.altroTest !== "true") {
            confermaDiLaboratorioMorbillo.altroTest = ""
            confermaDiLaboratorioMorbillo.altroTestValore = ""
            confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest = ""
            confermaDiLaboratorioMorbillo.esitoAltroTest = ""
            confermaDiLaboratorioMorbillo.tipoCampioneAltroTest = ""
            confermaDiLaboratorioMorbillo.eventualeAltroAltroTest = ""
        }
        if (confermaDiLaboratorioMorbillo.genotipizzazione !== "true") {
            confermaDiLaboratorioMorbillo.genotipizzazione = ""
            confermaDiLaboratorioMorbillo.ceppoGenotipizzazione = ""
        }
        if (confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgm !== "3") {
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgm = ""
        }
        if (confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgg !== "3") {
            confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgg = ""
        }
        if (confermaDiLaboratorioMorbillo.tipoCampionePcr !== "4") {
            confermaDiLaboratorioMorbillo.eventualeAltroPcr = ""
        }
        if (confermaDiLaboratorioMorbillo.tipoCampioneAltroTest !== "4") {
            confermaDiLaboratorioMorbillo.eventualeAltroAltroTest = ""
        }
        if (confermaDiLaboratorioMorbillo.ricercaIgmElisaOAltro !== "2") {
            confermaDiLaboratorioMorbillo.ricercaIgmAltroValore = ""
        }
        if (confermaDiLaboratorioMorbillo.ricercaIggElisaOAltro !== "2") {
            confermaDiLaboratorioMorbillo.ricercaIggAltroValore = ""
        }

        this.setState({confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo})
        this.controlloCorrettezza()
        Utils.disabledDateTabellaConfermaLaboratorio("Morbillo", this.state)
        this.props.updateConferme({
            confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo,
            corretto: confermaDiLaboratorioMorbillo.corretto
        })
    }

    controlloCorrettezza() {
        let confermaDiLaboratorioMorbillo = this.state.confermaDiLaboratorioMorbillo
        confermaDiLaboratorioMorbillo.corretto = []

        if (confermaDiLaboratorioMorbillo.esamiEffettuati === "1") {
            if (!confermaDiLaboratorioMorbillo.ricercaIgg && !confermaDiLaboratorioMorbillo.ricercaIgm &&
                !confermaDiLaboratorioMorbillo.pcr && !confermaDiLaboratorioMorbillo.altroTest) {
                confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
            }
            if(confermaDiLaboratorioMorbillo.ricercaIgm === "true"){
                if(!confermaDiLaboratorioMorbillo.ricercaIgmElisaOAltro) confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
                if((!confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm  ||
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm), "-"))){
                    confermaDiLaboratorioMorbillo.corretto[1] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioMorbillo.esitoRicercaIgm )  confermaDiLaboratorioMorbillo.corretto[2] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgm || (confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgm === "3" && !confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgm))  confermaDiLaboratorioMorbillo.corretto[3] = "Campo \"Tipo di campione\" mancante";
                if(confermaDiLaboratorioMorbillo.ricercaIgmElisaOAltro === "2" && !confermaDiLaboratorioMorbillo.ricercaIgmAltroValore) confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
            }
            if (confermaDiLaboratorioMorbillo.ricercaIgg === "true"){
                if(!confermaDiLaboratorioMorbillo.ricercaIggElisaOAltro) confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
                if((!confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg || (confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg), "-")) ||
                    !confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg || (confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg), "-")))){
                    confermaDiLaboratorioMorbillo.corretto[1] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioMorbillo.esitoRicercaIgg )  confermaDiLaboratorioMorbillo.corretto[2] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgg || (confermaDiLaboratorioMorbillo.tipoCampioneRicercaIgg === "3" && !confermaDiLaboratorioMorbillo.eventualeAltroRicercaIgg))  confermaDiLaboratorioMorbillo.corretto[3] = "Campo \"Tipo di campione\" mancante";
                if(confermaDiLaboratorioMorbillo.ricercaIggElisaOAltro === "2" && !confermaDiLaboratorioMorbillo.ricercaIggAltroValore) confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
            }
            if (confermaDiLaboratorioMorbillo.pcr === "true"){
                if(!confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr || (confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr),"-"))){
                    confermaDiLaboratorioMorbillo.corretto[1] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioMorbillo.esitoPcr) confermaDiLaboratorioMorbillo.corretto[2] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioMorbillo.tipoCampionePcr || (confermaDiLaboratorioMorbillo.tipoCampionePcr === "4" && !confermaDiLaboratorioMorbillo.eventualeAltroPcr)) confermaDiLaboratorioMorbillo.corretto[3] = "Campo \"Tipo di campione\" mancante";
            }
            if (confermaDiLaboratorioMorbillo.altroTest === "true"){
                if(!confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest || !confermaDiLaboratorioMorbillo.altroTestValore ||
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest), "-")){
                        confermaDiLaboratorioMorbillo.corretto[1] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioMorbillo.esitoAltroTest) confermaDiLaboratorioMorbillo.corretto[2] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioMorbillo.tipoCampioneAltroTest || (confermaDiLaboratorioMorbillo.tipoCampioneAltroTest === "4" && !confermaDiLaboratorioMorbillo.eventualeAltroAltroTest)) confermaDiLaboratorioMorbillo.corretto[3] = "Campo \"Tipo di campione\" mancante";
            }
            if (confermaDiLaboratorioMorbillo.genotipizzazione === "true" && !confermaDiLaboratorioMorbillo.ceppoGenotipizzazione) {
                confermaDiLaboratorioMorbillo.corretto[0] = "Campo \"Tipo esame\" mancante";
            }
        }
        else if (confermaDiLaboratorioMorbillo.esamiEffettuati !== "2") confermaDiLaboratorioMorbillo.corretto[4] = "Campo \"Effettuati esami di laboratorio per la diagnosi di morbillo?\" mancante";

        this.setState({confermaDiLaboratorioMorbillo: confermaDiLaboratorioMorbillo})
    }


    render() {

        const {t} = this.props

        const info = (
            <div>
                <p style={{fontSize: "12px", fontWeight: "bold"}}>
                    {t("SchedaSpecialeMorbillo.misurazione")}</p>
            </div>
        )

        const intestazione = (
            <div>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.effettuatiEsamiMorbillo")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>

                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <RadioButton id={"esamiEffettuatiMorbilloSi"} name={"esamiEffettuatiMorbillo"}
                                         label={t("SchedaSpecialeMorbillo.si")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.confermaDiLaboratorioMorbillo.esamiEffettuati === "1"}>
                            </RadioButton>
                            <RadioButton id={"esamiEffettuatiMorbilloNo"} name={"esamiEffettuatiMorbillo"}
                                         label={t("SchedaSpecialeMorbillo.no")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.confermaDiLaboratorioMorbillo.esamiEffettuati === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                </div>
                <u style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginTop: "0.5rem"
                }}>{t("SchedaSpecialeMorbillo.morbillo")}</u>
            </div>
        )

        return (
            <div>
                {intestazione}
                <fieldset disabled={this.state.confermaDiLaboratorioMorbillo.esamiEffettuati === "1" ? false : true}>
                    <TabellaConfermaLaboratorio
                        id={"Morbillo"}
                        confermaDiLaboratorio={this.state.confermaDiLaboratorioMorbillo}
                        riceviValore={this.riceviValore}
                        segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>
                </fieldset>
                {info}
            </div>
        );
    }

}

export default withTranslation('common')(ConfermaDiLaboratorioMorbillo)
